module.exports = __webpack_public_path__ + "img/small-arrow-up.93d9fb4b.svg";